import { useEffect, useState } from "react";
import { FormModalControlled } from "../../components/Modal";
import Input from "../../components/Input";
import Label from "../../components/Label";

const NumberSeqEditorModal = ({ isOpen, onClose, param, onSave }) => {
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [step, setStep] = useState("");

  useEffect(() => {
    if (isOpen && param) {
      // Try to recover from/to/step from existing values
      const existing = param.steps?.[0]?.options || [];
      if (existing.length >= 2) {
        const nums = existing.map(Number).filter((n) => !Number.isNaN(n));
        if (nums.length >= 2) {
          setFrom(String(nums[0]));
          setTo(String(nums[nums.length - 1]));
          setStep(nums.length >= 2 ? String(nums[1] - nums[0]) : "1");
          return;
        }
      }
      setFrom("");
      setTo("");
      setStep("");
    } else if (!isOpen) {
      setFrom("");
      setTo("");
      setStep("");
    }
    // eslint-disable-next-line
  }, [isOpen]);

  const fromNum = Number(from);
  const toNum = Number(to);
  const stepNum = Number(step);

  const isValid =
    from !== "" &&
    to !== "" &&
    step !== "" &&
    !Number.isNaN(fromNum) &&
    !Number.isNaN(toNum) &&
    !Number.isNaN(stepNum) &&
    stepNum > 0 &&
    toNum >= fromNum;

  const generateValues = () => {
    const values = [];
    for (let v = fromNum; v <= toNum; v += stepNum) {
      values.push(String(v));
    }
    return values;
  };

  const handleSubmit = () => {
    if (!isValid) return;
    const values = generateValues();
    onSave?.(values);
    onClose?.();
  };

  return (
    <FormModalControlled
      isOpen={isOpen}
      onClose={onClose}
      onCancel={onClose}
      onSubmit={handleSubmit}
      submitLabel="Gerai"
      cancelLabel="Atšaukti"
      disabled={!isValid}
    >
      <h2>{param?.label || "Skaičių seka"}. Pridėti reikšmių seką</h2>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "var(--gap)",
          margin: "var(--gap) 0",
          minWidth: "min(400px, 80vw)",
        }}
      >
        <Label>Naudoti skaičių validatorių:</Label>
        <Input
          label="Nuo"
          type="number"
          value={from}
          onChange={(e) => setFrom(e.target.value)}
        />
        <Input
          label="Iki"
          type="number"
          value={to}
          onChange={(e) => setTo(e.target.value)}
        />
        <Input
          label="Žingsnis"
          type="number"
          value={step}
          onChange={(e) => setStep(e.target.value)}
        />
        {isValid && (
          <div style={{ opacity: 0.6 }}>
            Reikšmės: {generateValues().join(", ")}
          </div>
        )}
      </div>
    </FormModalControlled>
  );
};

export default NumberSeqEditorModal;
